var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2597 9.12388C13.123 8.2791 14.5077 8.29413 15.3525 9.15746V9.15746C16.2158 10.0395 16.2158 11.4499 15.3525 12.332L13.2375 14.4795L13.2109 14.5061C12.5275 15.1748 11.4314 15.1629 10.7626 14.4795L8.64751 12.332C7.78418 11.4499 7.78418 10.0395 8.64751 9.15747V9.15747L8.68107 9.12391C9.09564 8.71822 9.6544 8.49384 10.2344 8.50013C10.8144 8.50643 11.3682 8.74288 11.7739 9.15747L12 9.38704L12.2261 9.15745L12.2597 9.12388Z",
    stroke: "#414042",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6566 5.35098V5.35098C20.7808 8.48993 20.7808 13.5635 17.6566 16.7025V16.7025L14.3448 20.0254C13.0558 21.3205 10.9609 21.3255 9.66581 20.0365L9.65481 20.0254L6.34291 16.7025C3.21877 13.5635 3.21874 8.48998 6.34285 5.35098V5.35098C9.45234 2.22678 14.5057 2.21485 17.6299 5.32433L17.6566 5.35098H17.6566Z",
    stroke: "#414042",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.17c1155e.svg";
export { ForwardRef as ReactComponent };